<template>
    <v-container style="padding-top: 80px">
        <v-card class="pb-0 mb-5 " style="border-left: 0.25rem solid var(--v-anchor-base); !important;">
            <v-card-title class="pa-5 pb-3">
                <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10" style="display: grid; place-items: center;">
                        <p style="color: var(--v-anchor-base);" class="title-text-style text-center">Notificaciones
                            Pendientes</p>
                    </v-col>
                    <v-col cols="12" md="1" style="display: grid; place-items: center;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" fab dark small v-bind="attrs" v-on="on" @click="Lideres()">
                                    <v-icon size="20" color="white"> mdi-binoculars </v-icon>
                                </v-btn>
                            </template>
                            <span>Principal</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <v-card class="pt-1 pb-0" elevation="5">
            <v-container>
                <DataTableLideres :url="urlListado" :columns="columns" :params="displayInputs" :order="[]"
                    @apiDT="apiDT = $event" :formatterActions="formatterActions">
                </DataTableLideres>
            </v-container>
        </v-card>
    </v-container>
</template>
<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import DataTableLideres from "@/components/pages/Lideres/components/DataTableNet/DataTable";
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
    components: { DataTableLideres },
    data() {
        return {
            urlListado: 'Lideres/NotificacionApp',
            columns: [
                { name: "Reporte", data: "Reporte", title: "Reporte", formatter: [this, "formatearReporte"], orderable: false },
                { name: "Fecha", data: "exfecha", title: "Fecha", orderable: false, },
                { name: "Fecha abo", data: "exfechaabo", title: "Fecha abo", orderable: false, },
                { name: "Tipo", data: "cegrupo", title: "Tipo", orderable: false, },
                { name: "Concepto", data: "ceconcepto", title: "Concepto", orderable: false, },
                { name: "Observaciones", data: "exobs", title: "Observaciones", orderable: false, },
                { name: "Usuario", data: "uslogin", title: "Usuario", orderable: false, },
                { name: "Líder", data: "lduslogin", title: "Líder", orderable: false, },
            ],
            displayInputs: {
                opc: undefined,
            },
            apiDT: null,
            formatterActions: [
                { click: [this, "BuscarReporte"] },
            ],
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        Lideres() {
            this.$router.push({ name: `LideresMain` }).catch(error => error);
        },
        formatearReporte(datos) {
            if ((datos.aiclave == 1 || datos.aiclave == 23 || datos.aiclave == 24 || datos.aiclave == 5)) {
                return `<div class="ml-4"><button type="button" class="mr-1 dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos}" aria-expanded="false"><span class='reporteindice'>${datos.nrreporte}-${datos.svindice}</span></button></div>`;
            } else {
                return `<span>${datos.nrreporte}-${datos.svindice}</span>`;
            }
        },
        async BuscarReporte(params, item, fila) {
            let reporte = {
                nrreporte: item.nrreporte,
                svindice: item.svindice,
                aiclave: item.aiclave,
                svfhconclusion: item.svfhconclusion
            };
            var ver = 0;
            let formData = new FormData();
            formData.append("nrreporte", item.nrreporte);
            formData.append("svindice", item.svindice);
            await SerBusqueda.ObtenerValidacion(this, formData).then(data => {
                ver = data;
            });

            if (ver == 0) {
                this.$router.push({ name: `${"DatosIncompletos"}` }).catch(error => error);
            }
            else {
                await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');
                this.$router.push({ name: `${"Asistencias"}` });
            }
        },
    }
}
</script>
<style scoped>
.title-text-style {
    font-family: Poppins, sans-serif;
    font-size: 32px !important;
    font-weight: bold !important;
}
</style>